export default __webpack_public_path__ + "img/bIAwCKeU.313b600c.svg";